<template>
  <a
    aria-label="Chat on WhatsApp"
    href="https://wa.me/6281315013050"
    target="_blank"
    class="fixed hidden md:block z-50 bottom-5 right-5 2xl:bottom-10 2xl:right-10"
  >
    <img
      alt="Chat on WhatsApp"
      src="../../public/img/icon/WhatsAppButtonGreenLarge.svg"
      class="2xl:w-96"
    />
  </a>

  <a
    aria-label="Chat on WhatsApp"
    href="https://wa.me/6281315013050"
    target="_blank"
    class="fixed block md:hidden z-50 left-3 bottom-20 mb-1"
  >
    <img
      alt="Chat on WhatsApp"
      src="../../public/img/icon/WhatsAppButtonGreenSmall.svg"
    />
  </a>
</template>
<script>
export default {
  name: "WhatsappWidget",
};
</script>
